import { Checkbox } from "@progress/kendo-react-inputs";
import styles from "./Settings.module.scss";
import ReportDesignerImage from "../../assets/Settings/MenuSettings/ReportDesigner.png";
import EditIcon from "../../assets/edit.png";

export const SignatureCell = (props) => {
  const { dataItem, field, dataIndex } = props;
  const isEven = dataIndex % 2 === 0;
  const initial = dataItem[field]?.[0]?.toUpperCase() || "";
  const colorClass = isEven ? styles.odd : styles.even;

  return (
    <td>
      <span
        className={`${styles["active-circle"]} ${colorClass} d-flex align-items-center justify-content-center`}
      >
        <span className={`${styles["icon-design"]} ${colorClass}`}>
          {initial}
        </span>
      </span>
    </td>
  );
};

export const VatReturnCell = (props) => {
  return (
    <td className="text-center align-middle">
      <div style={{ transform: "scale(1.3)", transformOrigin: "center" }}>
        <Checkbox checked={props.dataItem.includeInVatReturn} readOnly={true} />
      </div>
    </td>
  );
};

export const ActiveCell = (props) => {
  return (
    <td className="text-center align-middle">
      <div style={{ transform: "scale(1.3)", transformOrigin: "center" }}>
        <Checkbox checked={props.dataItem.active} readOnly={true} />
      </div>
    </td>
  );
};

export const ReportDesignerButton = (props) => {
  return (
    <td>
      <img
        onClick={() => {
          props.enterEdit(props.dataItem);
        }}
        className="ms-4 cursor-pointer"
        src={ReportDesignerImage}
      ></img>
    </td>
  );
};

export const AllowedDocumentCell = (props) => {
  return (
    <td className="text-center align-middle">
      <div className="d-inline-block" style={{ transform: "scale(1.3)" }}>
        <Checkbox
          checked={props.dataItem.allowDocument === true}
          readOnly={true}
        />
      </div>
    </td>
  );
};

export const AllowedTypeCell = (props) => {
  return (
    <td className={`${styles[`checkbox`] + " " + styles[`marginLeft`]}`}>
      <Checkbox
        checked={props.dataItem.allowTime === true ? true : false}
        readOnly={true}
      />
    </td>
  );
};

export const EditCommandCell = (props) => {
  return (
    <td>
      <img
        src={EditIcon}
        className="cursor-pointer"
        onClick={() => {
          props.enterEdit(props.dataItem);
        }}
      />
    </td>
  );
};

export const TemplateNameCell = (props) => {
  const { dataItem } = props;
  const isDefault = dataItem.default === true || (dataItem.defaultBranchId != null && dataItem.defaultBranchId !== undefined);
  
  return (
    <td>
      <div className="d-flex align-items-center gap-2">
        <span>{dataItem.templateName}</span>
        {isDefault && (
          <span className="fs-sm px-3 rounded-pill"
            style={{ backgroundColor: "#dcdaff" }}
          >
            Default
          </span>
        )}
      </div>
    </td>
  );
};

export const DefaultBranchCell = (props) => {
  const { dataItem } = props;
  
  let displayText = "";
  if (dataItem.default === true && (dataItem.defaultBranchId == null || dataItem.defaultBranchId === undefined)) {
    displayText = "All Branches";
  } else if (dataItem.defaultBranchName) {
    displayText = dataItem.defaultBranchName;
  }
  
  return (
    <td>
      <span>{displayText}</span>
    </td>
  );
};

export const VatDetailsCell = (props) => {
  const { dataItem } = props;
  
  return (
    <td className="ps-3">
      <div className="d-flex align-items-center gap-4">
        <span>{dataItem.details}</span>
        {dataItem?.isDefault === true && (
          <span 
            className="fs-sm px-2 py-1 rounded-pill"
            style={{ backgroundColor: "#dcdaff", color: "#333" }}
          >
            Default
          </span>
        )}
      </div>
    </td>
  );
};
